import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { ProductKeys, Editions } from "@atlassiansox/asc-stargate";

import { useCrossFlowFrontendTouchpoint } from "@/components/cross-flow/touchpoint";
import ContentBlock from "@/components/wpl/content-block/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";

const ctaSectionStyles = css({
    [media.above.md]: {
        backgroundImage:
            "url(https://dam-cdn.atl.orangelogic.com/AssetLink/1dah86u2hpv7o6d7e360581037843522.webp)"
    },
    "backgroundRepeat": "no-repeat",
    "backgroundSize": "cover",
    "backgroundPosition": "center",
    [media.below.md]: {
        backgroundImage:
            "url(https://dam-cdn.atl.orangelogic.com/AssetLink/t8bk75l2830f38g5c04562ik0423361c.webp)"
    },
    "color": "#ffffff",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".content-block": {
        "padding": "96px 0",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".text-section": {
            [media.above.md]: {
                padding: "64px 0"
            },
            [media.below.md]: {
                padding: "16px 0"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "h2": {
                [media.above.md]: {
                    fontSize: "2.25rem"
                },
                lineHeight: 1.33333333,
                letterSpacing: 0,
                fontWeight: 400,
                [media.below.md]: {
                    fontSize: "1.5rem",
                    marginBlockEnd: "14px"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            ".contentBlock-linkFlex": {
                "gap": 0,
                [media.below.md]: {
                    margin: 0
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                "a": {
                    fontWeight: 400
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                ".link-wrapper": {
                    marginInlineStart: "16px",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    a: {
                        fontWeight: 100
                    }
                }
            }
        }
    }
});

const CTASection = () => {
    const intl = useIntl();
    const signupLink = useLocalizedHref(
        "/software/jira/service-management/free"
    );
    const { openCrossFlow } = useCrossFlowFrontendTouchpoint({
        productKey: ProductKeys.JIRA_SERVICE_DESK,
        edition: Editions.FREE,
        redirectUrl: signupLink
    });
    const ctaButtonText = intl.formatMessage({
        id: "jira-service-management.cta.button",
        defaultMessage: "Try it free"
    });

    return (
        <section css={ctaSectionStyles}>
            <Row>
                <ContentBlock
                    headerText={intl.formatMessage({
                        id: "jira-service-management.cta.header",
                        defaultMessage:
                            "Get started with Jira Service Management today"
                    })}
                    headerType="h2"
                    isCentered={true}
                    ctaProps={{
                        buttonProps: {
                            text: ctaButtonText,
                            color: "yellow",
                            className: "jsm-hero-section-cta",
                            dataEventProps: {
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-event": "clicked",
                                "data-product-key": "jiraServiceManagement",
                                "data-label-english": "Try it free",
                                "data-label": ctaButtonText
                            },
                            onClick: openCrossFlow,
                            url: signupLink
                        },
                        secondaryLinkProps: {
                            text: intl.formatMessage({
                                id: "jira-service-management.cta.link",
                                defaultMessage: "Explore plans"
                            }),
                            href: useLocalizedHref(
                                "/software/jira/service-management/pricing"
                            ),
                            type: "primary",
                            bgColor: "bgBlackBlue",
                            dataEventProps: {
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-event": "clicked",
                                "data-product-key": "jiraServiceManagement"
                            }
                        }
                    }}
                />
            </Row>
        </section>
    );
};

export default CTASection;
